import { inject, Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { CapitalizeFirstPipe } from './capitalize-first.pipe';

@Pipe({
  name: 'translationKey',
  standalone: true,
})
export class TranslationKeyPipe<T extends { [key: string]: string }> implements PipeTransform {
  private readonly _translateService = inject(TranslateService);
  private readonly _capitalizeFirstPipe = new CapitalizeFirstPipe();

  transform(array: T[], translationKey: string, field = 'name'): T[] {
    if (!translationKey) {
      return array;
    }

    if (array?.length) {
      return array.map(item => {
        const value = item[field]
          .toLocaleLowerCase()
          .split(' ')
          .map((word, index) => (index === 0 ? word : this._capitalizeFirstPipe.transform(word)))
          .join('')
          .toString();

        const translatedValue = this._translateService.instant(`${translationKey}.${value}`);

        return {
          ...item,
          [field]: translatedValue,
        };
      });
    } else {
      return [];
    }
  }
}
